import type { RootState } from '@/store/store';

export const selectSocialSettings = (state: RootState) => state.pages.currentPage?.socialSettings;
